import { useMediaQuery } from '@/hooks/useMediaQuery'

/**
 * Whether the member asked for reduced motion.
 *
 * For motion that runs in script, which globals.css's reduced-motion rule
 * cannot reach: a count-up, a typewriter. Such an effect shows its end state
 * at once when this is true. Live, so a change in the OS setting applies
 * without a reload.
 */
export function useReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)')
}
